import React, { useCallback, useState } from 'react';
import DynamicArgsWrapper from '../../containers/ArgsWarpper/ArgsWrapper';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { TArgs } from '../../types/policies-types';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import { updateProfilePolicyArgs } from '../../actions/policies-profile-actions/policy-state-actions';

const BooleanField: React.FC<React.PropsWithChildren<TArgs>> = props => {
  const { name, label, value, policyId, tooltip } = props;
  const [inputValue, setInputValue] = useState<boolean>(value as boolean);

  const handleChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
      enablePoliciesSaveButton(true);
      setInputValue(checked);
      updateProfilePolicyArgs({
        id: policyId,
        name,
        value: checked,
      });
    },
    [name, policyId],
  );
  return (
    <DynamicArgsWrapper meta={{ name, tooltip }}>
      <Box p={0.5}>
        <FormControlLabel
          sx={{
            '&.MuiFormControlLabel-root': {
              marginLeft: 'unset',
            },
          }}
          labelPlacement='start'
          control={
            <Checkbox
              name={name}
              size='small'
              onChange={handleChange}
              checked={inputValue}
            />
          }
          label={
            <Typography color='text.secondary' variant='caption'>
              {label}
            </Typography>
          }
        />
      </Box>
    </DynamicArgsWrapper>
  );
};

export default BooleanField;
